/**
 * Rasterize PDF pages to JPEG data URLs so they appear in browser print output.
 * Embedded PDFs (<embed>/<iframe>) are often omitted from printed pages; images are not.
 */
export async function rasterizePdfBlobToJpegDataUrls(blob, options = {}) {
  const maxPages = options.maxPages ?? 40;
  const scale = options.scale ?? 2;

  const pdfjsLib = await import('pdfjs-dist/webpack.mjs');
  const data = await blob.arrayBuffer();
  const pdf = await pdfjsLib.getDocument({ data }).promise;
  const n = Math.min(pdf.numPages, maxPages);
  const out = [];
  for (let i = 1; i <= n; i += 1) {
    const page = await pdf.getPage(i);
    const viewport = page.getViewport({ scale });
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d', { alpha: false });
    if (!ctx) throw new Error('Canvas 2D context unavailable');
    canvas.width = viewport.width;
    canvas.height = viewport.height;
    const renderTask = page.render({
      canvasContext: ctx,
      viewport
    });
    await renderTask.promise;
    out.push(canvas.toDataURL('image/jpeg', 0.88));
  }
  return out;
}
